

class Cookieser {

    /**
     * Set cookeis
     * 
     * @param {String} cname - cookie name
     * @param {Any} cvalue - value
     * @param {Number} exdays - expired days
     */
    set = (cname, cvalue, exdays) => {
        const d = new Date()
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)) //
        let expires = "expires=" + d.toUTCString()
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
    }


    /**
     * Get cookies
     * @param {String} cname - cookie name
     * @returns 
     */
    get = (cname) => {
        let name = cname + "="
        let decodedCookie = decodeURIComponent(document.cookie)
        let ca = decodedCookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) == ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ""
    }

}

const Cookies = new Cookieser()

export default Cookies